<template>
  <fts-design-modal
    title="Packing Module"
    desc="Pack a module so can use again in other workspace"
    ref="ftsDesignModal">
    <!-- body -->
    <template #body>
      <!-- key -->
      <fts-form-element
        :item="{
          fieldName: 'key',
          type: 0,
          required: true,
        }"
        :form-data="formData"
        :validator="$v.formData"
        comfort-design />
      <!-- version -->
      <fts-form-element
        :item="{
          fieldName: 'version',
          type: 0,
          required: true,
        }"
        :form-data="formData"
        :validator="$v.formData"
        comfort-design />
    </template>
    <!-- footer -->
    <template #footerLeft> </template>
    <template #footerRight>
      <fts-btn text @click="beforeClose">Cancel</fts-btn>

      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import changesets from "diff-json";

import commons from "../commons/commons";

import FTSDesignModal from "./FTSDesignModal";
import FTSBtn from "../elements/FTSBtn";
import FTSFormElement from "../elements/FTSFormElement";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
    "fts-form-element": FTSFormElement,
  },
  data: () => ({
    formData: {},
    originalData: {},
    resolve: null,
  }),
  validations() {
    let formData = {};
    const fields = [
      { type: 0, fieldName: "key", required: true },
      { type: 0, fieldName: "version", required: true },
    ];
    formData = commons.getFormValidators(fields);
    return { formData };
  },
  methods: {
    async show() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.reset();
            }
          }
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    async done() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        try {
          await this.$store.dispatch("packModule", this.formData);
          this.resolve && this.resolve(this.formData);
          this.$toasted.success("Submitted successfully.");
          this.reset();
        } catch(err) {
          if (err.response && err.response.data && err.response.data.message)
            this.$toasted.error(err.response.data.message);
          else
            this.$toasted.error("Failed to pack module.")
        }
      }
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    reset() {
      this.$v.$reset();
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>